export const baselineFollowupInfo = {
  title: "Baseline & Follow-up Definition",
  sections: [
    {
      heading: "Baseline Assessment",
      items: [
        "The PHQ-9 assessment closest to the program/start date within a window of \u221214 to +14 days.",
        "If multiple assessments exist in this window, the closest to the start date is selected.",
        "If no assessment exists within this window, the patient is excluded from change-based metrics.",
      ],
    },
    {
      heading: "Follow-up Assessment",
      items: [
        "The most recent PHQ-9 assessment after the baseline within the selected date range.",
      ],
    },
    {
      heading: "Note",
      items: [
        "A minimum of two assessments (baseline + follow-up) is required for change-based metrics.",
        "If only one valid assessment exists, the patient is excluded.",
      ],
    },
  ],
};

export const improvementInfo = {
  title: "PHQ-9 Improvement",
  sections: [
    {
      heading: "Definition",
      items: [
        "Reduction in PHQ-9 score from baseline to follow-up.",
      ],
    },
    {
      heading: "Eligible Patients",
      items: [
        "Baseline identified within \u221214 to +14 days of start date, AND",
        "At least one follow-up assessment available, AND",
        "Baseline PHQ-9 score > 5",
      ],
    },
    {
      heading: "Breakdown",
      items: [
        "Improved: Follow-up score < baseline",
        "Not Improved: Follow-up score \u2265 baseline",
      ],
    },
    {
      heading: "Excluded",
      items: [
        "No baseline in defined window",
        "No follow-up assessment",
        "Missing/invalid scores",
        "Baseline score \u2264 5",
      ],
    },
  ],
};

export const worseningInfo = {
  title: "PHQ-9 Worsening",
  sections: [
    {
      heading: "Definition",
      items: [
        "Increase in PHQ-9 score from baseline to follow-up.",
      ],
    },
    {
      heading: "Eligible Patients",
      items: [
        "Baseline within \u221214 to +14 days of start date, AND",
        "At least one follow-up assessment, AND",
        "Baseline PHQ-9 score > 5",
      ],
    },
    {
      heading: "Breakdown",
      items: [
        "Worsened: Follow-up score > baseline",
        "Not Worsened: Follow-up score \u2264 baseline",
      ],
    },
    {
      heading: "Excluded",
      items: [
        "No baseline in defined window",
        "No follow-up assessment",
        "Missing/invalid scores",
        "Baseline score \u2264 5",
      ],
    },
  ],
};

export const partialImprovementInfo = {
  title: "PHQ-9 Partial Improvement (\u226550% Reduction)",
  sections: [
    {
      heading: "Definition",
      items: [
        "At least 50% reduction in PHQ-9 score from baseline.",
      ],
    },
    {
      heading: "Eligible Patients",
      items: [
        "Baseline within \u221214 to +14 days of start date, AND",
        "At least one follow-up assessment, AND",
        "Baseline PHQ-9 score > 5",
      ],
    },
    {
      heading: "Breakdown",
      items: [
        "Responders: \u2265 50% reduction from baseline",
        "Non-Responders: < 50% reduction",
      ],
    },
    {
      heading: "Excluded",
      items: [
        "No baseline in defined window",
        "No follow-up assessment",
        "Missing/invalid scores",
        "Baseline score \u2264 5",
      ],
    },
  ],
};

export const mcidImprovementInfo = {
  title: "MCID Improvement",
  sections: [
    {
      heading: "Definition",
      items: [
        "Minimum Clinically Important Difference (MCID) — a reduction of 5 or more points from baseline, indicating a meaningful clinical change.",
      ],
    },
    {
      heading: "Eligible Patients",
      items: [
        "Baseline within −14 to +14 days of start date, AND",
        "At least one follow-up assessment, AND",
        "Baseline score > 5",
      ],
    },
    {
      heading: "Breakdown",
      items: [
        "Improved: Follow-up score decreased by ≥ 5 points from baseline",
        "Not Improved: Follow-up score decreased by < 5 points from baseline",
      ],
    },
    {
      heading: "Excluded",
      items: [
        "No baseline in defined window",
        "No follow-up assessment",
        "Missing/invalid scores",
        "Baseline score ≤ 5",
      ],
    },
  ],
};

export const remissionInfo = {
  title: "PHQ-9 Remission",
  sections: [
    {
      heading: "Definition",
      items: [
        "PHQ-9 score < 5, indicating minimal or no depression symptoms.",
      ],
    },
    {
      heading: "Eligible Patients",
      items: [
        "Patients with a valid latest PHQ-9 assessment within the selected range.",
      ],
    },
    {
      heading: "Breakdown",
      items: [
        "In Remission: Latest score < 5",
        "Not in Remission: Latest score \u2265 5",
      ],
    },
    {
      heading: "Excluded",
      items: [
        "Missing/invalid latest score",
      ],
    },
  ],
};
